<template>
  <div class="login">
    <div class="box">
      <div class="header">
        <img :src="bannerImg">
      </div>
      <van-cell-group>
        <div class="fx fx-items-center area-box">
          <img style="width: 14px; height: 16px" src="https://ebuyimg.e-mallchina.com/olvp/phone.png" alt="">
          <div class="code fx fx-items-center" @click="onCountryTap">
            +{{phoneCode}}
            <van-icon name="arrow-down" />
          </div>
          <van-field
          v-model="loginParams.phone"
          placeholder="Phone number"
          @input="onPhoneTap"
          @blur="blur"
          @focus="focus"
          type="tel"
          @click="inputClick"
          :error-message="errPhone ? 'Phone number format is not correct.' : ''"
        />
        </div>
      </van-cell-group>
      <van-cell-group class="fx fx-items-center">
        <van-field
          v-model="loginParams.password"
          left-icon="https://ebuyimg.e-mallchina.com/olvp/sms.png"
          center
          clearable
          @blur="blur"
          maxlength="20"
          @focus="focus"
          :type="wordType"
          placeholder="Password"
          @input="onPasswordTap"
          :error-message="errWord ? 'Password format is not correct.' : ''"
        >
          <template #button>
            <span @click="onForgotTap">Forgot</span>
          </template>
        </van-field>
        <!-- <van-icon v-if="wordType === 'password'" name="closed-eye" size="18" @click="changePassType()" />
        <van-icon v-else name="eye-o" size="18" @click="changePassType()" /> -->
      </van-cell-group>
      <van-button class="login-btn" :disabled="errWord || errPhone || !loginParams.password || !loginParams.phone" round type="info" size="large" @click="onLoginTap">Login</van-button>
      <div class="fx fx-center fx-items-center">
        <span class="blue" @click="onRegisterTap">Sign-up</span>
        <van-icon name="arrow" color="#388BFF" />
      </div>
    </div>
    <!-- :style="{'position': showOther ? 'absolute' : 'static'}" -->
    <div class="other">
      <van-divider>Or Continue with</van-divider>
      <ul class="channel fx fx-center">
        <li v-for="item in loginTypeItems" :key="item.platformId">
          <img src="@/assets/img/fb.png" @click="onThirdTap(item.platformName)" v-if="item.platformName === 'facebook'">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      option: [],
      errPhone: false,
      loginParams: {
        phone: '',
        password: '',
        country: '',
        bindingAccount: '',
        platformName: 'sms'
      },
      bannerImg: '',
      loginTypeItems: [],
      backPath: '',
      wordType: 'password',
      showOther: true,
      phoneCode: '',
      country: '',
      errWord: false
    }
  },
  created () {
    this.backPath = this.$route.query.backPath || '/home'
    this.phoneCode = this.$util.storageGet('local', 'phoneCode')
    this.country = this.$util.storageGet('local', 'country')
    if (!this.$util.storageGet('local', 'phoneCode')) {
      this.$util.storageSet('local', 'phoneCode', this.phoneCode)
      this.$util.storageSet('local', 'country', this.country)
    }
    this.loginParams.country = this.country
    this.loadData()
  },
  methods: {
    // 获取登录方式列表
    getListPlatform (params) {
      return this.$http.post('/olvp/getListPlatform', 'getListPlatform', params, false, false)
    },
    // 手机号码登录
    newOlvpLogin (params) {
      return this.$http.post('/olvp/newOlvpLogin', 'newOlvpLogin', params, false, false)
    },
    loadData () {
      const env = process.env.NODE_ENV
      let params = {
        appId: env === 'production' ? 'ebuycbd665bf3891' : 'ebuycbd665bf3891'
      }
      this.getListPlatform(params).then((d) => {
        if (d.success) {
          if (d.content.loginPictureUrlList.length > 0) {
            this.bannerImg = d.content.loginPictureUrlList[0].loginPictureUrl
          }
          let platform = d.content.platformList
          platform.map((v) => {
            if (v.platformName !== 'sms') {
              this.loginTypeItems.push(v)
            }
          })
        }
      })
    },
    inputClick () {

    },
    onPasswordTap (e) {
      // 至少包含字母数组符合其中两种
      let reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/
      if (reg.test(e)) {
        this.errWord = false
      } else {
        this.errWord = true
      }
    },
    backHome () {
      this.$router.replace('/home')
    },
    // 输入手机号
    onPhoneTap (e) {
      if (this.checkPhoneNumber(e)) {
        this.errPhone = false
      } else {
        this.errPhone = true
      }
    },
    // 忘记密码
    onForgotTap () {
      this.$router.push(`/register?type=reset&platform=sms&backPath=${encodeURIComponent(this.backPath)}`)
    },
    // 点击登录
    onLoginTap () {
      this.$cux.loading()
      const fbId = this.$util.storageGet('local', 'facebookId') || ''
      this.loginParams.bindingAccount = fbId
      this.newOlvpLogin(this.loginParams).then((d) => {
        this.$cux.loadend()
        if (d.success) {
          window._czc.push(['_trackEvent', '点击', '登陆'])
          if (d.content.success === 'true') {
            this.$util.storageSet('local', 'platform', 'sms')
            this.$util.storageSet('local', 'phone', this.loginParams.phone)
            this.$util.storageSet('local', 'token', d.content.token)
            this.$util.storageSet('local', 'picture', d.content.profilePhotoUrl)
            this.$util.storageSet('local', 'name', d.content.memberName)
            this.$util.storageSet('local', 'memberId', d.content.memberId)
            // 判断当前登录手机号 与缓存中的fbid是否为同一用户 不同则清掉缓存fbid
            if (d.content.isSameMember !== fbId) {
              this.$util.storageDel('local', 'facebookId')
            }
            if (this.$route.query.backPath) {
              this.$router.replace(this.$route.query.backPath)
            } else {
              this.backHome()
            }
          } else {
            this.$cux.toast(d.content.message)
          }
        }
      })
    },
    // 三方授权
    onThirdTap (e) {
      if (e === 'facebook') {
        this.$router.push(`/thirdAuth?platformName=${e}&backPath=${encodeURIComponent(this.backPath)}`)
      }
    },
    // 注册
    onRegisterTap () {
      this.$router.push(`/register?type=reg&platform=sms&backPath=${encodeURIComponent(this.backPath)}`)
    },
    // 切换国家
    onCountryTap () {
      this.$router.push(`/country?backPath=${encodeURIComponent(this.backPath)}`)
    },
    checkPhoneNumber (phoneNumber) {
      const reg = this.$pattern.phonei18n
      let num = 0
      for (const key in reg) {
        const regx = reg[key]
        if (regx.test(phoneNumber)) {
          num++
        }
      }
      if (num === 0) {
        return false
      }
      return true
    },
    changePassType () {
      this.wordType = this.wordType === 'text' ? 'password' : 'text'
    },
    focus () {
      this.showOther = false
    },
    blur () {
      this.showOther = true
    }
  }
}
</script>

<style lang="scss">
  .login {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 40px 20px;
    .van-dropdown-menu {
      width: 65px;
      .van-dropdown-menu__title {
        padding: 0 8px 0 0;
      }
      .van-dropdown-menu__bar {
        box-shadow: none;
      }
    }
    .box {
      .header {
        width: 100%;
        margin-bottom: 30px;
      }
      margin: 0 auto;
      .area-box {
        padding: 0 16px;
        img {
          margin-right: 5px;
        }
        .code {
          font-weight: 500;
        }
        .van-icon {
          display: block;
          font-weight: 500;
          margin-left: 5px;
        }
      }
      .logo {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        margin-bottom: 80px;
      }
      .login-btn {
        margin: 30px 0;
      }
    }
    .other {
      padding: 0 20px;
      font-size: 12px;
      width: auto;
      margin-top: 100px;
      box-sizing: border-box;
      width: 100%;
      .van-divider {
        width: 100%;
      }
      .channel {
        img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          margin: 0 10px;
        }
      }
    }
    .van-dropdown-menu::after {
      border: none;
    }
  }
</style>
